import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import AuthService from '../../services/auth.service';

const Layout = () => {
  const [showSidebar, setShowSidebar] = useState(true);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleLogout = () => {
    AuthService.logout();
    navigate('/login');
  };

  return (
    <div className="dashboard-layout d-flex">
      <Sidebar className={showSidebar ? 'show' : ''} />
      <div className="main-wrapper flex-grow-1">
        <Navbar onToggleSidebar={toggleSidebar} onLogout={handleLogout} />
        <div className="content-wrapper p-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout; 